export type ErrorWithContextOptions = ErrorOptions & {
  context?: Record<PropertyKey, unknown>;
};
// eslint-disable-next-line fabric-ui/no-class
export class ErrorWithContext extends Error {
  static extractContext = (error: unknown): ErrorWithContextOptions['context'] => (isErrorWithContext(error) ? error.dd_context : {});
  readonly dd_context: Record<PropertyKey, unknown>;
  constructor(message: string, options?: ErrorWithContextOptions) {
    const { cause, context } = options || {};
    super(message, { cause });
    this.name = 'ErrorWithContext';
    this.dd_context = context || {};
  }
}

export const isErrorWithContext = (error: unknown): error is ErrorWithContext =>
  error instanceof ErrorWithContext && error.name === 'ErrorWithContext';
